import { useState } from 'react';
import ClickOutside from '../../../../common/widgets/ClickOutside';
import AppBar from './components/AppBar';
import NavBar from './components/NavBar';

export default function Header() {
  const [displayMenu, setDisplayMenu] = useState<boolean>(false);

  return (
    <div className="header-sticky">
      <AppBar onMenuClick={setDisplayMenu} isMenuOpen={displayMenu} />
      <ClickOutside onClickOutside={() => setDisplayMenu(false)}>
        <NavBar
          showMenu={displayMenu}
          closeMenu={() => setDisplayMenu(false)}
        />
      </ClickOutside>
    </div>
  );
}
